import { css } from 'lit';
import { hostReset, focusRing } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: inline-flex;
    }

    /* ── Base ────────────────────────────────────────────────────────────────── */
    .uwc-chip {
      display: inline-flex;
      align-items: center;
      gap: 0.375rem;
      /* em-based height tracks the chip font so it scales with the size presets */
      height: 2.15em;
      padding: 0 ${t.space3};
      border-radius: var(--uwc-chip-radius, ${t.radiusFull});
      background: var(--uwc-chip-bg, var(--uwc-surface-raised, #f9f8f5));
      border: none;
      color: var(--uwc-chip-color, var(--uwc-text, ${t.text}));
      font-size: var(--uwc-chip-font-size, ${t.fontSizeMd});
      font-weight: var(--uwc-chip-font-weight, ${t.fontWeightMedium});
      font-family: var(--uwc-font-family, inherit);
      white-space: nowrap;
      user-select: none;
    }

    /* ── Sizes (em-based height tracks font-size, so it scales too) ──────────── */
    :host([size="small"]) .uwc-chip { font-size: var(--uwc-chip-font-size, ${t.fontSizeSm}); padding: 0 ${t.space2}; }
    :host([size="large"]) .uwc-chip { font-size: var(--uwc-chip-font-size, ${t.fontSizeLg}); padding: 0 ${t.space4}; }

    /* ── Remove left padding only when a real image URL is present ───────────── */
    :host([image]:not([image=""])) .uwc-chip {
      padding-left: 0;
    }

    /* ── Avatar image ────────────────────────────────────────────────────────── */
    .uwc-chip__image {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
      display: block;
    }

    /* ── Icon ────────────────────────────────────────────────────────────────── */
    .uwc-chip__icon {
      display: inline-flex;
      flex-shrink: 0;
      color: var(--uwc-chip-icon-color, var(--uwc-text-secondary, ${t.textSecondary}));
    }

    /* ── Label ───────────────────────────────────────────────────────────────── */
    .uwc-chip__label {
      line-height: 1;
    }

    /* ── Remove button ───────────────────────────────────────────────────────── */
    .uwc-chip__remove {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 1.125rem;
      height: 1.125rem;
      margin-right: -0.25rem;
      padding: 0;
      background: none;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      color: var(--uwc-chip-remove-color, var(--uwc-text-secondary, ${t.textSecondary}));
      opacity: 0.65;
      transition:
        opacity ${t.durationBase} ease,
        background ${t.durationBase} ease,
        color ${t.durationBase} ease;
      flex-shrink: 0;
    }

    .uwc-chip__remove:hover {
      opacity: 1;
      background: color-mix(in oklab, currentColor 12%, transparent);
      color: var(--uwc-text, ${t.text});
    }

    .uwc-chip__remove:focus-visible {
      outline: 2px solid var(--uwc-color-primary, ${t.primary});
      outline-offset: 1px;
      opacity: 1;
    }

    /* ── Reduced motion ──────────────────────────────────────────────────────── */
    @media (prefers-reduced-motion: reduce) {
      .uwc-chip__remove { transition: none; }
    }
  `,
  focusRing('.uwc-chip'),
];
